import React from 'react';
import styles from './ClassificationBadge.module.css';

export type ClassificationBadgeProps = {
  label: string;
  backgroundColor: string;
  textColor: string;
  className?: string;
};

const ClassificationBadge: React.FC<ClassificationBadgeProps> = ({
  label,
  backgroundColor,
  textColor,
  className = '',
}) => (
  <span
    className={`${styles.badge} ${className}`.trim()}
    style={{
      backgroundColor,
      color: textColor,
    }}
  >
    {label}
  </span>
);

export default ClassificationBadge;
